module.exports = __webpack_public_path__ + "static/media/kyc_before.c1440e35.png";